<template>
	<div class="versions">
		<div class='count'>
			<el-button size="mini" @click="release" v-if="userInfo.userType == 1">新增发布</el-button>
			共{{ versionHistory.length }}条版本记录
			<el-button type="text" @click="viewDetail">
              版本详情
            </el-button>
		</div>
		<div>
			<!-- <div class="pop-title">历史版本信息</div> -->
			<versionItem
				v-for="(data, index) in versionHistory"
				:key="index"
				:versionData="data"
			>
				<span class="current" v-if="!index"> 当前版本 </span>
			</versionItem>
		</div>
	</div>
</template>
<script>
import versionItem from "./components/versionItem";
import { mapGetters } from "vuex";

export default {
	mane: "versions",
	components: {
		versionItem,
	},
	data() {
		return {
			version: {},
			versionHistory: [],
		};
	},
	computed: {
		...mapGetters(["userInfo"])
	},
	mounted() {
		this.requestVersionHistory();
	},
	methods: {
		requestVersionHistory() {
			this.$api.ocsGetVersionHistory().then((res) => {
				if (res && res.errcode == 0) {
					console.log(res);
					this.version = res.data[0];
					this.versionHistory = res.data;
				}
			});
		},
		release() {
			this.$router.push({path: "/versions/release"});
		},
		viewDetail() {
			window.open(
				"https://majorel.feishu.cn/docs/doccndcskpHUXqhj9uARenTNhLf",
				"target"
			);
		},
	},
};
</script>
<style lang="scss" scoped>
.versions {
	font-size: 14px;
	height: 100%;
	overflow: scroll;
	padding: 20px;
	.count {
		text-align: right;
		margin-bottom: 12px;
		color: #566980;
	}
	.current {
		font-size: 16px;
		font-weight: 500;
		color: #ff504d;
		margin-left: 19px;
	}
}
</style>